<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>for</span></p>
<p class="ded1"><span>Bill Segal</span></p>
<p class="ded1"><span>who disturbs my sleep</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?671ba092